<template>

    <KedvezmenyekBase>

        <v-layout row wrap slot="kedvezmeny" ref="kedvezmeny" style="max-width: 100%;">

            <BnFormField v-if="showOtpdolg" :attributes="otpdolg"/>

            <BnFormField v-if="showOtpbankszla" :attributes="otpbankszla"/>

            <BnFormField v-if="showLakbizt" :attributes="lakbizt"/>

            <BnFormField v-if="showCasco" :attributes="casco"/>

            <BnFormField v-if="showCsaladitobbjarmu" :attributes="csaladitobbjarmu"/>

            <BnFormField v-if="showPreventor" :attributes="preventor"/>

            <BnFormField v-if="showEletbizt" :attributes="eletbizt"/>

        </v-layout>

    </KedvezmenyekBase>

</template>

<script>
import { MOTOR, SZGK, TEHER } from '../../../../../../../modules/Gepjarmu';
import BnFormField from '../../../../../../basecomponents/BnFormField.vue';
import Kedvezmeny from '../../../../mixins/dijak/kedvezmenyek/Kedvezmeny';
import KedvezmenyekBase from '../KedvezmenyBase.vue';
import TariffAnnouncementUtils from '../../../../../../../utils/TariffAnnouncementUtils';

export default {
    name: 'KedvezmenyekB8',
    mixins: [Kedvezmeny],
    components: {BnFormField, KedvezmenyekBase},
    methods: {
        isMaganszemely() {
            return this.isTermeszetesSzemely();
        },
        isJoFajta() {
            return [MOTOR, TEHER, SZGK].includes(this.getValue('gepjarmu.fajta'));
        },
    },
    data() {
        // TODO összes attribute-ot computedba rakni
        return {
            otpdolg: {
                type: 'checkbox',
                label: 'Groupama társasági és OTP bankcsoporti kedvezmény',
                visible: true,
                editable: !this.disabled,
                help: true,
                mezo: 'groupama_otpdolg',
                path: 'kedvezmenyekbiztosito.8.otpdolg',
                change: this.shouldRecalc,
            },
            otpbankszla: {
                type: 'checkbox',
                label: 'OTP folyószámla kedvezmény',
                visible: true,
                editable: !this.disabled,
                help: true,
                mezo: 'groupama_otpbankszla',
                path: 'kedvezmenyekbiztosito.8.otpbankszla',
                change: this.shouldRecalc,
            },
            lakbizt: {
                type: 'select',
                label: 'Lakásbiztosítás kedvezmény',
                visible: true,
                editable: !this.disabled,
                help: true,
                mezo: 'groupama_lakbizt',
                path: 'kedvezmenyekbiztosito.8.lakbizt',
                change: this.shouldRecalc,
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    { key: 0, value: 'Nincs' },
                    { key: 1, value: '1 db' },
                    { key: 2, value: '2 db' },
                ],
            },
            csaladitobbjarmu: {
                type: 'select',
                label: 'Gfb többjármű kedvezmény',
                visible: true,
                editable: !this.disabled,
                rules: [],
                help: true,
                mezo: 'groupama_csaladitobbjarmu',
                path: 'kedvezmenyekbiztosito.8.csaladitobbjarmu',
                change: this.shouldRecalc,
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    {key: 0, value: 'Nincs'},
                    {key: 1, value: '1 db'},
                    {key: 2, value: '2 db'},
                ],
            },
            preventor: {
                type: 'checkbox',
                label: 'Preventor vagyon és felelőségbiztosítás',
                visible: true,
                editable: !this.disabled,
                rules: [],
                help: true,
                mezo: 'groupama_preventor',
                path: 'kedvezmenyekbiztosito.8.preventor',
                change: this.shouldRecalc,
            },
            eletbizt: {
                type: 'select',
                label: 'Életbiztosítás kedvezmény',
                visible: true,
                editable: !this.disabled,
                rules: [],
                help: true,
                mezo: 'groupama_eletbizt',
                path: 'kedvezmenyekbiztosito.8.eletbizt',
                change: this.shouldRecalc,
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    {key: 0, value: 'Nincs'},
                    {key: 1, value: '1 db'},
                    {key: 2, value: '2 db'},
                ],
            },
        };
    },
    computed: {
        showOtpdolg() {
            return this.isJoFajta()
                && this.isMaganszemely();
        },
        showOtpbankszla() {
            return this.isJoFajta()
                && this.isMaganszemely()
                && TariffAnnouncementUtils.isKockakezdetLesser(2025, 'kgfb', this.$store);
        },
        showLakbizt() {
            return this.isJoFajta()
                && this.isMaganszemely()
                && TariffAnnouncementUtils.isKockakezdetLesser(2025, 'kgfb', this.$store);
        },
        showCasco() {
            return this.isJoFajta()
                && this.isMaganszemely()
                && TariffAnnouncementUtils.isKockakezdetLesser(2025, 'kgfb', this.$store);
        },
        casco() {
            return {
                type: 'select',
                label: 'Cascobiztosítás kedvezmény',
                visible: true,
                editable: !this.disabled && !this.egyuttkotve,
                help: true,
                mezo: 'groupama_casco',
                path: 'kedvezmenyekbiztosito.8.casco',
                change: this.shouldRecalc,
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    { key: 0, value: 'Nincs' },
                    { key: 1, value: '1 db' },
                    { key: 2, value: '2 db' },
                ],
            };
        },
        showCsaladitobbjarmu() {
            return this.isJoFajta()
                && this.isMaganszemely()
                && TariffAnnouncementUtils.isKockakezdetLesser(2025, 'kgfb', this.$store);
        },
        showPreventor() {
            return this.isJoFajta()
                && !this.isMaganszemely()
                && TariffAnnouncementUtils.isKockakezdetLesser(2025, 'kgfb', this.$store);
        },
        showEletbizt() {
            return this.isJoFajta()
                && this.isMaganszemely()
                && TariffAnnouncementUtils.isKockakezdetLesser(2025, 'kgfb', this.$store);
        },
    },
};
</script>
